export const colors = {
  primary: '#418C95',
  primaryDark: '#357A85',
  primaryLight: '#5BA3B0',
  secondary: '#DF8955',
  secondaryLight: '#E59B6B',
  accent: '#E74C3C',
  
  background: '#FFFFFF',
  backgroundGrey: '#F8F9FA',
  text: '#2C2C2C',
  textLight: '#666666',
  textMuted: '#999999',
  border: '#E0E0E0',
  success: '#27AE60',
  warning: '#F39C12',
  error: '#E74C3C',
  white: '#FFFFFF',
  black: '#000000',
};

export default colors;
